import { render, staticRenderFns } from "./CcTagsFilter.ts.vue?vue&type=template&id=4edd8d0e"
import script from "./CcTagsFilter.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcTagsFilter.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcTagsFilter.ts.vue?vue&type=style&index=0&id=4edd8d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports